import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CampaignCard = ({ campaign, onViewDetails, onMessage, onUpdateStatus }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'completed':
        return 'bg-primary/10 text-primary';
      case 'disputed':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return 'PlayCircle';
      case 'pending':
        return 'Clock';
      case 'completed':
        return 'CheckCircle';
      case 'disputed':
        return 'AlertCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start gap-4">
        <Image
          src={campaign?.influencerAvatar}
          alt={campaign?.influencerAvatarAlt}
          className="w-16 h-16 rounded-full object-cover flex-shrink-0"
        />
        
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-foreground truncate">{campaign?.title}</h3>
              <p className="text-sm text-muted-foreground">{campaign?.influencerName}</p>
            </div>
            <div className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(campaign?.status)}`}>
              <Icon name={getStatusIcon(campaign?.status)} size={14} />
              <span className="capitalize">{campaign?.status}</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-3">
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Calendar" size={16} className="text-muted-foreground" />
              <span className="text-muted-foreground">{campaign?.deadline}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Icon name="TrendingUp" size={16} className="text-muted-foreground" />
              <span className="text-foreground font-medium">{campaign?.reach}</span>
            </div>
          </div>

          <div className="flex items-center justify-between mb-3">
            <div className="flex-1">
              <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                <span>İlerleme</span>
                <span>{campaign?.progress}%</span>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary transition-all duration-300"
                  style={{ width: `${campaign?.progress}%` }}
                />
              </div>
            </div>
            <div className="ml-4 text-right">
              <p className="text-lg font-semibold text-foreground">{campaign?.budget}</p>
              <p className="text-xs text-muted-foreground">Bütçe</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              iconName="MessageSquare"
              iconPosition="left"
              onClick={() => onMessage(campaign?.id)}
              className="flex-1"
            >
              Mesaj
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="Eye"
              iconPosition="left"
              onClick={() => onViewDetails(campaign?.id)}
              className="flex-1"
            >
              Detaylar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;